import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Laptop, Monitor, Smartphone } from "lucide-react";

const BASE = "https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com";

function getOrCreateDeviceId() {
  let id = localStorage.getItem("teche_device_id");
  if (!id) {
    const rnd = crypto.randomUUID?.() ||
      ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    localStorage.setItem("teche_device_id", rnd);
    id = rnd;
  }
  return id;
}

export default function CompleteRegistration() {
  const { state } = useLocation();
  const planKey = state?.planKey || "BASIC";
  const navigate = useNavigate();

  async function onContinue() {
    // persist the chosen plan in case of refresh
    sessionStorage.setItem("selected_plan", planKey);
    // include it in the URL too (deep-link safe)
    //navigate(`/register?plan=${encodeURIComponent(planKey)}`);
      // if user is signed in → go to carrello; else → register
   const user = JSON.parse(localStorage.getItem("user") || "null");
   if (user?.email) {
     // pass the plan both in state and query so refresh keeps it
     navigate(`/carrello?subscription=${encodeURIComponent(planKey)}`, {
       state: { planKey }
     });
   } else {
     navigate(`/register?plan=${encodeURIComponent(planKey)}`);
   }
}

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="max-w-md w-full text-center px-6">
        {/* devices row */}
        <div className="flex justify-center gap-6 text-[#324B8E] mb-6">
          <Laptop size={48} />
          <Monitor size={48} />
          <Smartphone size={48} />
        </div>

        
        <h1 className="text-3xl font-bold leading-tight mb-4">
          Completa la<br />registrazione<br />dell'account
        </h1>

        <p className="text-neutral-700 mb-8">
          Te.C.H-e è su misura per te. Crea una password per iniziare a usare i tour digitali.
        </p>

        <button
          onClick={onContinue}
          className="w-full rounded-md py-3 text-white text-lg font-semibold bg-[#324B8E]"
        >
          Continua
        </button>

        <div className="text-2xl text-black mt-4">
          Piano selezionato: <span className="font-medium">{planKey}</span>
        </div>
      </div>
    </div>
  );
}
